import { format } from 'date-fns'

/**
 * SC-10890: texto do tooltip do indicador de abertura.
 *
 * A contagem fica no TOOLTIP, não em badge nem número solto ao lado do ícone:
 * badge é o vocabulário de "aja agora" (o único do sistema é o vermelho do
 * NotificationCenter) e criaria 25 pontos de atenção por página; número entre
 * ButtonRounded de 42px desalinha a fila da coluna de ações. A contagem aparece
 * escrita, sem hover, dentro da timeline.
 *
 * Regra dura: `viewsCount` só produz CONTAGEM quando > 1. Front e back sobem em
 * momentos diferentes, então `undefined` tem que cair no comportamento booleano
 * antigo — nunca "abriu 0 vezes".
 *
 * A data da última abertura, porém, aparece SEMPRE que existir, inclusive na
 * abertura única: "quando ele viu" é a informação que decide a conversa de
 * cobrança ("abriu hoje de manhã" e "abriu em julho" pedem abordagens
 * diferentes), e antes ela só surgia a partir da segunda abertura.
 */
export const buildOpenTooltip = (
  viewed?: boolean,
  viewsCount?: number,
  lastViewedAt?: string | null
): string => {
  if (!viewed) return 'Cliente não abriu a fatura'

  const when = formatLastView(lastViewedAt)
  const times = viewsCount && viewsCount > 1 ? `${viewsCount} vezes` : null

  // Sem contagem confiável nem data (base legada), mantém o texto de antes.
  if (!times && !when)
    return 'Cliente abriu a fatura · clique para ver o histórico'

  const opening = times
    ? `Cliente abriu a fatura ${times}`
    : 'Cliente abriu a fatura'

  return when ? `${opening} · ${times ? 'última em' : 'em'} ${when}` : opening
}

const formatLastView = (value?: string | null): string | null => {
  if (!value) return null

  try {
    return format(new Date(value), "dd/MM/yyyy 'às' HH:mm")
  } catch (err) {
    // Data inválida vinda da API não pode virar "Invalid date" na tela.
    return null
  }
}
